module.exports = __webpack_public_path__ + "static/media/mail.f0849768.png";